import React from "react";
import TopoTexture from "@/components/TopoTexture";
import { ClipboardList, CalendarCheck, Truck, Home } from "lucide-react";

const steps = [
  { icon: <ClipboardList className="w-6 h-6" />, title: "Request a Quote", text: "Call us or fill the form — free, no-obligation estimate tailored to your move in Casper or surrounding Wyoming areas." },
  { icon: <CalendarCheck className="w-6 h-6" />, title: "Plan Your Move", text: "We build a custom plan: crew size, trucks, packing needs, special items, and timing." },
  { icon: <Truck className="w-6 h-6" />, title: "Moving Day", text: "Our professional Wyoming movers arrive on time, protect your property, and handle every item carefully." },
  { icon: <Home className="w-6 h-6" />, title: "Settle In", text: "We place, reassemble, and unpack so you can enjoy your new home or office without the stress." },
];

const ProcessSection = () => {
  return (
    <section data-testid="process-section" className="relative py-20 md:py-32 bg-[var(--ct-accent)] overflow-hidden">
      <TopoTexture variant="light" opacity={0.035} />
      <div className="section-container relative">
        <div className="max-w-3xl mb-14">
          <div className="label-xs text-[var(--ct-primary)] mb-3">Our Moving Process in Casper, WY</div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-[var(--ct-primary)] tracking-tight" style={{ fontFamily: "Outfit" }}>
            Simple, organized, and completely stress-free.
          </h2>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-4">
          {/* connecting line */}
          <div className="hidden md:block absolute top-8 left-[12.5%] right-[12.5%] h-[2px] bg-[var(--ct-primary)]/20" />

          {steps.map((s, i) => (
            <div key={i} data-testid={`process-step-${i + 1}`} className="relative flex flex-col items-start">
              <div className="relative z-10 w-16 h-16 rounded-full bg-[var(--ct-primary)] text-white flex items-center justify-center shadow-[0_10px_20px_rgba(26,54,43,0.25)]">
                {s.icon}
              </div>
              <div className="mt-5">
                <div className="text-xs font-bold tracking-[0.25em] uppercase text-[var(--ct-secondary)]">Step {i + 1}</div>
                <h3 className="mt-2 text-xl font-semibold text-[var(--ct-primary)]" style={{ fontFamily: "Outfit" }}>
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-[var(--ct-text-muted)] leading-relaxed">{s.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
